const ERROR_MODAL_COMPONENT = 'modalContainer/cancelLoanApplication',
  ERROR_MODAL_EVENT_ACTION = 'modalCancelLoanApplication';

export { ERROR_MODAL_COMPONENT, ERROR_MODAL_EVENT_ACTION };
